import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './configure-email.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';
let $ = require('jquery');

@Component({
  selector: 'configure-email',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./configure-email.scss')],
  template: require('./configure-email.html')
})

export class ConfigureEmail {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Output('onClose') selfClose = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private emailList = '';
  private isRequestPending: boolean = false;
  private isDataLoading: boolean = false;

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit(f: NgForm) {
    if (f.valid) {
       switch(this.mode){
        case DataProtectionVariables.MODES['VAPP']:
          this.configureEmailVapp(f.value);
          break;
        case DataProtectionVariables.MODES['VDC']:
          this.configureEmailVDC(f.value);
          break;
        default :
          this.configureEmailVapp(f.value);
       }
    }
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue
      && this.selectedVDC && this.selectedVDC.id) {
      if (this.mode && this.mode === DataProtectionVariables.MODES['VDC']) {
        this.getEmailVDC(this.selectedVDC.id);
      }
      if (this.mode && this.mode === DataProtectionVariables.MODES['VAPP']
        && this.selectedObject && this.selectedObject.constructor === Array
        && this.selectedObject.length > 0 && this.selectedObject[0].id) {
          this.getEmailVapp(this.selectedVDC.id, this.selectedObject[0].id);
      }
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if (this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  constructEmailObject(emailList) {
    let emails = (emailList && $.trim(emailList) != '') ? emailList.split(',') : [];
    return {
      emailIds: emails
    };
  }

  configureEmailVapp(formValue) {
    if (formValue && this.selectedVDC && this.selectedVDC.id !== '' &&
       this.selectedObject && this.selectedObject[0] && this.selectedObject[0].id && this.selectedObject[0].id !== '') {
         let emailObj = this.constructEmailObject((formValue.email)? formValue.email : '');
          this.isRequestPending = true;
          this.subscribeHandler = this.service.configureEmailVapp(this.selectedVDC.id, this.selectedObject[0].id, emailObj)
            .subscribe(
              res => {
                this.reset();
                this.closeSelf();
              },
              error => this.logError(error, 'Configure Email for vApp'),
              () => this.logOperationCompleted('Configure Email for vApp')
            );
    }
    else
      this.logError('Incorrect VDC or vApp information');
  }

  configureEmailVDC(formValue) {
    if (formValue && this.selectedVDC && this.selectedVDC.id !== '') {
         let emailObj = this.constructEmailObject( (formValue.email)? formValue.email : '');
          this.isRequestPending = true;
          this.subscribeHandler = this.service.configureEmailVDC(this.selectedVDC.id, emailObj)
            .subscribe(
              res => {
                this.reset();
                this.closeSelf();
              },
              error => this.logError(error, 'Configure Email for VDC'),
              () => this.logOperationCompleted('Configure Email for VDC')
            );
    }
    else
      this.logError('Incorrect VDC information');
  }

  getEmailVapp(vdcId, vappId) {
    this.emailList = '';
    this.isDataLoading = true;
    this.subscribeHandler = this.service.getEmailVapp(vdcId, vappId)
      .subscribe(
        (eList: any) => {
          this.emailList = (eList && eList.emailIds && eList.emailIds.constructor === Array)? eList.emailIds.join(', ') : '';
        },
        error => this.logError(error, 'get Email Vapp'),
        () => this.logOperationCompleted('get Email Vapp')
      );
  }

  getEmailVDC(vdcId) {
    this.emailList = '';
    this.isDataLoading = true;
    this.subscribeHandler = this.service.getEmailVDC(vdcId)
      .subscribe(
        (eList: any) => {
          this.emailList = (eList && eList.emailIds && eList.emailIds.constructor === Array)? eList.emailIds.join(', ') : '';
        },
        error => this.logError(error, 'get Email VDC'),
        () => this.logOperationCompleted('get Email VDC')
      );
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: 'close'
      });
    }
  }

  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
    this.emailList = null;
  }


  logError(error, origin:String = '') {
    this.isRequestPending = false;
    this.isDataLoading = false;
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
    this.isRequestPending = false;
    this.isDataLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/configure-email/configure-email.component.ts